import i18n from "../../../i18n"

export function bindShuffleMessageI18nEvents() {
    i18n.on("loaded", () => {
        i18n.loadNamespaces("common/shuffle_messages")
        updateTranslations()
    })
    i18n.on("languageChanged", () => {
        i18n.loadNamespaces("common/shuffle_messages")
        updateTranslations()
    })
}

function updateTranslations() {
    preview.forEach((key, index) => {
        if (i18n.hasLoadedNamespace("common/shuffle_messages")) {
            preview[index] = i18n.t(`preview.${index}`, { ns: "common/shuffle_messages" })
        }
    });
    publish.forEach((key, index) => {
        if (i18n.hasLoadedNamespace("common/shuffle_messages")) {
            publish[index] = i18n.t(`publish.${index}`, { ns: "common/shuffle_messages" })
        }
    });
    updatePreview.forEach((key, index) => {
        if (i18n.hasLoadedNamespace("common/shuffle_messages")) {
            updatePreview[index] = i18n.t(`update_preview.${index}`, { ns: "common/shuffle_messages" })
        }
    });
    updatePublish.forEach((key, index) => {
        if (i18n.hasLoadedNamespace("common/shuffle_messages")) {
            updatePublish[index] = i18n.t(`update_publish.${index}`, { ns: "common/shuffle_messages" })
        }
    });
    cloneApp.forEach((key, index) => {
        if (i18n.hasLoadedNamespace("common/shuffle_messages")) {
            cloneApp[index] = i18n.t(`clone_app.${index}`, { ns: "common/shuffle_messages" })
        }
    });
    messagesForPublishInRuntimeIframe.forEach((key, index) => {
        if (i18n.hasLoadedNamespace("common/shuffle_messages")) {
            messagesForPublishInRuntimeIframe[index] = i18n.t(`messages_for_publish_in_runtime_iframe.${index}`, { ns: "common/shuffle_messages" })
        }
    });
    messagesWhenCreatingProject.forEach((key, index) => {
        if (i18n.hasLoadedNamespace("common/shuffle_messages")) {
            messagesWhenCreatingProject[index] = i18n.t(`messages_when_creating_project.${index}`, { ns: "common/shuffle_messages" })
        }
    });
}

const preview = [
    "Wait while we are working on generating your App Workspace (preview)",
    "We are generating your exclusive database",
    "We are generating the display pages for your app",
    "Do you know that the bigger the app, the longer it takes",
    "It's still faster than you could code it",
    "The server is powered by a lemon and two electrodes",
    "While the satellite moves into position",
    "At least you are not on hold"
]

const publish = [
    "Wait while we are working on generating your App Workspace",
    "We are generating your exclusive database",
    "We are generating the display pages for your app",
    "Do you know that the bigger the app, the longer it takes",
    "It's still faster than you could code it",
    "The server is powered by a lemon and two electrodes",
    "While the satellite moves into position",
    "At least you are not on hold"
]

const updatePreview = [
    "Wait while we are working on updating your App Workspace (preview)",
    "Do you know that the bigger the app, the longer it takes",
    "It's still faster than you could code it",
    "The server is powered by a lemon and two electrodes",
    "While the satellite moves into position",
    "At least you are not on hold"
]

const updatePublish = [
    "Wait while we are working on updating your App Workspace",
    "Do you know that the bigger the app, the longer it takes",
    "It's still faster than you could code it",
    "The server is powered by a lemon and two electrodes",
    "While the satellite moves into position",
    "At least you are not on hold"
]

const cloneApp = [
    "Hold tight, your app is on its way...",
    "Do you know that the bigger the app, the longer it takes",
    "It's still faster than you could code it",
    "Go ahead -- hold your breath!",
    "At least you are not on hold",
    "Swapping time and space...",
    "I'm going to walk the dog",
    "Whenever I find the key to success, someone changes the lock",
    "Please hold on as we reheat our coffee"
]

export const messagesForPublishInRuntimeIframe = [
    "Wait while we are updating your app model",
    "The bigger the app is, the longer it will take",
    "I think I am, therefore, I am. I think",
    "At least you are not on hold",
    "I swear it's almost done",
    "Optimism - is a lack of information"
]

export const messagesWhenCreatingProject = [
    "Working our no-code magic... ✨",
    "Planting the seeds of your new app... 🌱",
    "Summoning the app wizards... 🧙‍♂️",
    "Weaving app dreams into reality... 🌌",
    "Conjuring an app masterpiece... 🎨",
    "Composing an app symphony... 🎼"
]

export const messages = {
    "preview": preview,
    "publish": publish,
    "updatePreview": updatePreview,
    "updatePublish": updatePublish,
    "cloneApp": cloneApp
}